const toastConfig = {
  show: true,
  post: {
    success: {
      title: "Success",
      description: "{{resource}} has been created successfully",
    },
    error: {
      title: "Error",
      description: "An error occurred while creating {{resource}}",
    },
  },
  put: {
    success: {
      title: "Success",
      description: "{{resource}} has been updated successfully",
    },
    error: {
      title: "Error",
      description: "An error occurred while updating {{resource}}",
    },
  },
  get: {
    success: {
      title: "Success",
      description: "{{resource}} has been retrieved successfully",
    },
    error: {
      title: "Error",
      description: "An error occurred while fetching {{resource}}",
    },
  },
  destroy: {
    success: {
      title: "Success",
      description: "{{resource}} has been deleted successfully",
    },
    error: {
      title: "Error",
      description: "An error occurred while deleting {{resource}}",
    },
  },
};

export { toastConfig };
